var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table-column',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._t("default",null,null,scope)]}}],null,true)},'el-table-column',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2342a5c4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/table-column-element.vue
// module id = null
// module chunks = 